<script setup>
import { useLocalePath } from '#imports'

const props = defineProps({
  width: {
    type: String,
    default: 'full',
  },
  activityId: {
    type: String,
    default: '',
  },
  btnText: {
    type: String,
    default: '',
  },
  className: {
    type: [String, Object],
    default: '',
  },
})
const localePath = useLocalePath()
const route = useRoute()
</script>

<template>
  <NuxtLink
    :to="{ path: localePath(`/airdrop/${props.activityId}`), query: route.query }"
    external
    :no-prefetch="true"
    class="px-8 py-3 font-medium text-center bg-black rounded-full text-textOnBtn" :class="[
      width === 'full' ? 'w-full' : `w-[${width}]`,
      className,
    ]"
  >
    {{ btnText || $t('前往报名') }}
  </NuxtLink>
</template>
